module.exports = __webpack_public_path__ + "img/3.76739e1b.jpg";